import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getKycData(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const userReference = await self.servicesVars.getUserReference()
  const parsedResponse = parseResponse(response, userReference)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest() {
  const storeId = await self.servicesVars.getStoreId()
  const url = urls.getKycData + storeId
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response, userReference) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalKycData(rawData, userReference)

    return {
      success: true,
      data: appData,
    }
  }
  if (response.status.code === 404) {
    return {
      success: true,
      data: Formatter.parseExternalKycData({}, userReference),
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getKycData }
